var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckInCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12m-1.914-7.977c.254.342.527.479.86.479.331 0 .614-.156.82-.479l4.59-7.226c.126-.205.244-.43.244-.645 0-.459-.4-.752-.82-.752-.264 0-.518.157-.704.45l-4.17 6.699-1.982-2.559c-.244-.322-.46-.41-.733-.41-.29 0-.535.15-.672.376a.8.8 0 0 0-.119.425q.001.159.056.312.063.168.179.323z",
  clipRule: "evenodd"
})));
export { SvgCheckInCircle as c };
export default __webpack_public_path__ + "common/assets/svg/CheckInCircle.svg";